import React, { Component } from 'react';
import { classname } from 'utils';
import './Company.css';

const AWARDS = [
  { place: '1 место', text: 'Workspace Digital Awards в категории «Дизайн и брендинг. Упаковка и этикетка»' },
  { place: '1 место', text: 'Tagline Awards в категории «Лучшее поисковое продвижение»' },
  { place: '2 место', text: 'Tagline Awards в категории «Лучший сайт о промышленности»' },
  { place: '3 место', text: 'Рейтинг Рунета «ИТ: Облачные технологии и дата-центры»' },
  { place: '6 место', text: 'Рейтинг Рунета «Подрядчики еком-компаний: Коммуникации»' },
  { place: '3 место', text: 'Рейтинг Рунета «Металлургия: Производство, обработка»' },
  { place: '2 место', text: 'Tagline Awards в категории «Лучшая b2b-кампания»' },
  { place: '2 место', text: 'Tagline Awards «Лучшая кампания для телеком— / IT— / интернет-бизнеса»' },
];

const WHY_CARDS = [
  {
    title: 'Система вместо набора услуг',
    text: 'Брендинг, разработка и продвижение сайтов, интернет-маркетинг (SMM, SEO, контекст) связаны едиными правилами с общим KPI.',
    icon: '/company/why-1.png',
  },
  {
    title: 'Инженерная управляемость',
    text: 'Ценим ваше время. За 12 недель передаём платформу бренда, контент-каркас, план перформанс-кампаний и первый релиз сайта.',
    icon: '/company/why-2.png',
  },
  {
    title: 'Премиальный сервис',
    text: 'Ограничение на количество активных проектов, персональные руководители направлений, SLA по коммуникации и срокам.',
    icon: '/company/why-3.png',
  },
  {
    title: 'Честная коммуникация',
    text: 'Работаем на результат. Если задача не решает цели бизнеса — говорим открыто. Если нужно изменить подход — предлагаем варианты и обсуждаем.',
    icon: '/company/why-4.png',
  },
];

const BUSINESS_CARDS = [
  {
    title: 'Чёткая бренд-система',
    text: 'Позиционирование, Tone of Voice, визуальная платформа и единые правила для всех коммуникаций.',
    img: '/company/why-2.png',
  },
  {
    title: 'Готовые инструменты',
    text: 'Дизайн-система, сайт или лендинг, контент-пак и медиаматериалы.',
    img: '/company/why-5.png',
  },
  {
    title: 'Запущенные каналы роста',
    text: 'SEO-стратегия под нишевые запросы, контент-модель, работающие сообщества, контекстная реклама и SMM.',
    img: '/company/why-6.png',
  },
];

const STEPS = [
  { num: '01', title: 'Диагностика и цель', text: 'Проводим аудит, фиксируем бизнес-результаты и ограничения.' },
  { num: '02', title: 'Проектирование системы', text: 'Создаём платформу бренда, дизайн-систему, контент и медиа-план.' },
  { num: '03', title: 'Запуск и перформанс', text: 'Синхронно запускаем сайт, SEO, контекстную рекламу, SMM и креатив.' },
  { num: '04', title: 'Измерение и масштабирование', text: 'Тестируем гипотезы, проводим A/B-тесты, отслеживаем KPI и развиваем то, что работает.' },
];

const STANDARDS = [
  {
    title: 'SLA по коммуникации',
    text: 'Ответ в рабочие часы, еженедельные синки по статусам проекта, ежемесячные стратегические сессии, NPS и поддержка после запуска.',
  },
  {
    title: 'Качество и скорость',
    text: 'Ограничиваем количество активных проектов, чтобы держать планку эффективности.',
  },
  {
    title: 'Формат работы',
    text: 'Статусы — каждую неделю, презентация отчётов — каждый месяц, аудит качества менеджмента — каждый квартал.',
  },
];

class Company extends Component {
  cl = classname('company');

  render() {
    return (
      <div className={this.cl()}>

        {/* Hero */}
        <section className={this.cl('hero')}>
          <img className={this.cl('hero-bg')} src="/company/hero-bg.jpg" alt="" aria-hidden="true" />
          <div className={this.cl('hero-content')}>
            <h1 className={this.cl('hero-title')}>
              Создаём опыт бренда<br />для технологичных компаний
            </h1>
            <p className={this.cl('hero-sub')}>
              Nimax — диджитал-агентство полного цикла. Создаём комплексный маркетинг и проектируем бренды как единую систему.
            </p>
          </div>
        </section>

        {/* Tagline */}
        <section className={this.cl('tagline')}>
          <p className={this.cl('tagline-text')}>
            <span className={this.cl('tagline-accent')}>Стратегия, брендинг, креатив, SMM, SEO и контекстная реклама</span>
            {' '}становятся одним управляемым контуром, а сложные продукты — понятными, желанными и измеримо эффективными.
          </p>
        </section>

        {/* Image band */}
        <section className={this.cl('image-band')}>
          <div className={this.cl('image-band-track')}>
            {[...Array(2)].map((_, rep) =>
              [1,2,3,4,5,6,7].map(n => (
                <img
                  key={`${rep}-${n}`}
                  className={this.cl('image-band-item')}
                  src={`/company/why-${n}.png`}
                  alt=""
                  aria-hidden="true"
                />
              ))
            )}
          </div>
        </section>

        {/* Stats */}
        <section className={this.cl('stats')}>
          <h2 className={this.cl('section-title')}>Цифры и факты о нас</h2>
          <div className={this.cl('stats-grid')}>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>25+</div>
              <div className={this.cl('stat-label')}>лет в индустрии</div>
            </div>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>70+</div>
              <div className={this.cl('stat-label')}>специалистов в команде</div>
            </div>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>Отрасли</div>
              <div className={this.cl('stat-label')}>Работаем с IT/SaaS, Fintech, промышленным B2B, e-commerce</div>
            </div>
            <div className={this.cl('stat')}>
              <div className={this.cl('stat-num')}>Основатели</div>
              <div className={this.cl('stat-founders')}>
                <div className={this.cl('founders-photos')}>
                  <img src="/company/founder-1.png" alt="Никита Михеенков" />
                  <img src="/company/founder-2.png" alt="Максим Коновалов" />
                </div>
                <div className={this.cl('stat-label')}>Никита Михеенков и Максим Коновалов</div>
              </div>
            </div>
          </div>
        </section>

        {/* Awards */}
        <section className={this.cl('awards')}>
          <div className={this.cl('awards-header')}>
            <h2 className={this.cl('section-title')}>Награды и партнёрства</h2>
            <p className={this.cl('awards-sub')}>
              Nimax — сертифицированный партнёр Яндекс.Рекламы, аккредитованный партнёр myTarget и Еламы, победитель рейтингов и фестивалей рекламы, постоянный спикер профильных конференций.
            </p>
          </div>
          <div className={this.cl('awards-ticker-wrap')}>
            <div className={this.cl('awards-ticker')}>
              {[...AWARDS, ...AWARDS].map((a, i) => (
                <div key={i} className={this.cl('award-item')}>
                  <div className={this.cl('award-place')}>{a.place}</div>
                  <div className={this.cl('award-text')}>{a.text}</div>
                </div>
              ))}
            </div>
            <div className={this.cl('awards-ticker', { reverse: true })}>
              {[...AWARDS, ...AWARDS].map((a, i) => (
                <div key={i} className={this.cl('award-item')}>
                  <div className={this.cl('award-place')}>{a.place}</div>
                  <div className={this.cl('award-text')}>{a.text}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Nimax */}
        <section className={this.cl('why')}>
          <h2 className={this.cl('section-title')}>Почему выбирают Nimax</h2>
          <div className={this.cl('why-grid')}>
            {WHY_CARDS.map((card, i) => (
              <div key={i} className={this.cl('why-card')}>
                <div className={this.cl('why-card-top')}>
                  <h3 className={this.cl('why-card-title')}>{card.title}</h3>
                  <p className={this.cl('why-card-text')}>{card.text}</p>
                </div>
                <img className={this.cl('why-card-icon')} src={card.icon} alt="" aria-hidden="true" />
              </div>
            ))}
          </div>
        </section>

        {/* Clients logo ticker */}
        <section className={this.cl('clients')}>
          <div className={this.cl('clients-track')}>
            {[...Array(2)].map((_, rep) =>
              [1,2,3,4,5,6,7,8,9,10].map(n => (
                <img
                  key={`${rep}-${n}`}
                  className={this.cl('clients-logo')}
                  src={`/logos/client_logo_${n}.svg`}
                  alt=""
                  aria-hidden="true"
                />
              ))
            )}
          </div>
        </section>

        {/* Business results */}
        <section className={this.cl('business')}>
          <h2 className={this.cl('section-title')}>Что получит бизнес за 90 дней</h2>
          <div className={this.cl('business-grid')}>
            {BUSINESS_CARDS.map((card, i) => (
              <div key={i} className={this.cl('business-card')}>
                <h3 className={this.cl('business-card-title')}>{card.title}</h3>
                <p className={this.cl('business-card-text')}>{card.text}</p>
                <img
                  src={card.img}
                  alt=""
                  aria-hidden="true"
                  className={this.cl('business-card-img')}
                />
              </div>
            ))}
          </div>
        </section>

        {/* How we work */}
        <section className={this.cl('how')}>
          <h2 className={this.cl('section-title')}>Как мы подходим к работе</h2>
          <div className={this.cl('how-grid')}>
            {STEPS.map((step) => (
              <div key={step.num} className={this.cl('how-step')}>
                <div className={this.cl('how-step-top')}>
                  <h3 className={this.cl('how-step-title')}>{step.title}</h3>
                  <p className={this.cl('how-step-text')}>{step.text}</p>
                </div>
                <div className={this.cl('how-step-num')}>{step.num}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Fit or not */}
        <section className={this.cl('fit')}>
          <h2 className={this.cl('section-title')}>В каких случаях мы подойдём друг другу</h2>
          <div className={this.cl('fit-cols')}>
            <div className={this.cl('fit-col')}>
              <div className={this.cl('fit-label')}>Сработаемся, если</div>
              <ul className={this.cl('fit-list')}>
                <li>нужна консистентная система: стратегия → бренд → сайт → SEO/SMM/контекст</li>
                <li>важны прозрачные процессы и прогнозируемые результаты</li>
                <li>готовы работать по метрикам и быстрым итерациям</li>
              </ul>
            </div>
            <div className={this.cl('fit-col')}>
              <div className={this.cl('fit-label')}>Не подойдём, если</div>
              <ul className={this.cl('fit-list')}>
                <li>ищете решение небольшой разовой задачи или дизайн без стратегии</li>
                <li>не планируете измерять эффект и менять процессы</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Partners */}
        <section className={this.cl('partners')}>
          <div className={this.cl('partners-left')}>
            <h2 className={this.cl('section-title')}>Работаем с партнёрами</h2>
          </div>
          <div className={this.cl('partners-right')}>
            <p>Если наши условия работы — не совсем то, что вы ищете, — ничего страшного. У нас большая партнёрская сеть, в которой найдётся подходящий исполнитель. Мы работаем в одной экосистеме с проверенными экспертами, которым доверяем.</p>
            <p>Подберём подрядчика под вашу сферу, масштаб, локацию и бюджет. Останемся на связи и при необходимости подключимся к проекту.</p>
            <a href="/order/" className={this.cl('partners-btn')}>Оставить заявку</a>
          </div>
        </section>

        {/* Team */}
        <section className={this.cl('team')}>
          <div className={this.cl('team-top')}>
            <div className={this.cl('team-left')}>
              <h2 className={this.cl('section-title')}>Команда</h2>
            </div>
            <div className={this.cl('team-right')}>
              <p className={this.cl('team-text')}>
                Стратеги, дизайнеры и перформанс-маркетологи — мы уделяем много времени, чтобы сформировать команду. Каждый проект ведёт персональный менеджер, а процессы прозрачны для клиента.
              </p>
              <a href="https://hr.nimax.ru" target="_blank" rel="noreferrer" className={this.cl('team-link')}>
                <img src="/company/icon.png" alt="" aria-hidden="true" className={this.cl('team-link-icon')} />
                Карьера в Nimax
              </a>
            </div>
          </div>
          <div className={this.cl('team-photo-wrap')}>
            <img className={this.cl('team-photo')} src="/company/team.jpg" alt="Команда Nimax" />
          </div>
        </section>

        {/* Standards */}
        <section className={this.cl('standards')}>
          <h2 className={this.cl('section-title')}>Стандарты сервиса Nimax</h2>
          <div className={this.cl('standards-grid')}>
            {STANDARDS.map((s, i) => (
              <div key={i} className={this.cl('standard')}>
                <h3 className={this.cl('standard-title')}>{s.title}</h3>
                <p className={this.cl('standard-text')}>{s.text}</p>
              </div>
            ))}
          </div>
        </section>

      </div>
    );
  }
}

export default Company;
